import React, { Component } from 'react'
import AthletesList from '../../../../components/molecules/AthletesList'
import SubscribedList from '../../../../components/molecules/SubscribedList'
import Loading from '../../../../components/atoms/Loading'
import * as events from '../../../../utils/events'
class ListAthletes extends Component {
  

  state = {
    categories: [],
    categoriesFilter: [],
    status: 'loading',
    total: 0,
    data: [],
    dataFilter: [],
    is_filter: false
  }

  loadAthletes() {
    events.listAllAthletes(this.props.token)
    .then(resp => {
      
      // var categories = {}
      // resp.result.map(athlete => {
      //   if(!categories[athlete.category])
      //   categories[athlete.category] = []

      //   athlete.user_avatar = `${athlete.user_avatar ? `${window.URL_ASSETS_BASE}imgs/avt/${athlete.user_avatar}` : ''}`
        
      //   categories[athlete.category].push(athlete)
      //   return athlete
      // })

      this.setState({
        ...this.state,
        total: resp.total,
        status: 'done',
        data: resp.result,
        dataFilter: resp.result
      })
    })
  }

  componentWillMount() {
    events.loadCategories(this.props.token)
    .then(resp => {
      this.setState({
        ...this.state,
        categories: resp,
        categoriesFilter: resp,
      })
      this.loadAthletes()
    })
  }

  filter(data) {
    if(data.filter !== '') {
      var regex = new RegExp(data.filter.toLowerCase(), 'g')
      var dataFilter = this.state.data.filter(item => item.user_name.toLowerCase().match(regex))
      
      this.setState({
        dataFilter,
        is_filter: true
      })
    } else {
      this.setState({
        dataFilter: this.state.data,
        is_filter: false
      })
    }

    if(data.category !== '') {
      var categories = this.state.categories.filter(category => category.id === data.category)
      this.setState({
        categoriesFilter: categories,
        is_filter: false,
      })
    } else {
      this.setState({
        categoriesFilter: this.state.categories,
      })
    }

  }

  render() {
    return (
      <div>
        { this.state.status === 'loading'
          ? <Loading/>
          : (
            <div>
              <SubscribedList handleFilter={(data) => this.filter(data)} categories={this.state.categories} titleCategory="Lista de <b>Inscritos</b>" titleCategoryNumber={this.state.total}/>
              {this.state.categoriesFilter.map(category => {
                var data = this.state.dataFilter.filter(item => item.category === category.id)
                var is_filter = this.state.is_filter
                return (
                  ( ( (data.length > 0 && is_filter) || !is_filter) && (
                    <AthletesList key={category.id} data={data} titleCategory={category.description} titleCategoryNumber={data.length} />
                  ))
                )
              })}
            </div>
          )}
      </div>
    )
  }
}

export default ListAthletes



// WEBPACK FOOTER //
// ./src/components/templates/Event/ListAthletes/index.js